import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Modal, Button } from 'react-bootstrap';
import SummaryWindow from './SummaryWindow';
import CancelOutreachForm from '../../modules/Feedback/components/opportunity-box/CancelOutReachForm';
import SurveyEmailModal from '../../modules/Dashboard/components/SurveyEmailModal';

import OutreachPlanModal from '../../modules/Feedback/components/outreach-plan-modal';
import EditSenderModal from '../../modules/Feedback/components/edit-sender-modal';
import EditLanguageModal from '../../modules/Feedback/components/edit-language-modal';
import RequiredTVCollectorMappingSetup from '../../modules/Setup/pages/TruVoiceCollectorsPage/RequiredTVCollectorMappingSetup';
import {
  winLossCancelSurveys,
  requestEditWinLossOpportunityFeedbacks,
} from '../../modules/Dashboard/DashboardActions';
import createRequestFeedbackComponent, { OPPORTUNITY_COMPONENT_TYPE } from '../../modules/Dashboard/components/WinLossOpportunityTable/RequestOpportunityFeedbacks';

import {
  getObject,
  getIsAccount,
  getShowSummaryWindow,
} from './reducer';

import { closeSummaryWindow } from './actions';

const RequestOpportunityFeedbacks = createRequestFeedbackComponent(OPPORTUNITY_COMPONENT_TYPE);

class Manager extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentCancelContact: null,
      currentSurveyPlan: null,
      currentEditSenderSurvey: null,
      currentEditLanguageSurvey: null,
      selectedLanguage: null,
      availableLanguages: [],
    };
    this.handleCancelOutreach = this.handleCancelOutreach.bind(this);
    this.requestShowCancelContactWindow = this.requestShowCancelContactWindow.bind(this);
    this.handleRequestShowOutreachPlan = this.handleRequestShowOutreachPlan.bind(this);
    this.requestChangeSenderEmail = this.requestChangeSenderEmail.bind(this);
    this.requestChangeLanguage = this.requestChangeLanguage.bind(this);
    this.closeWarningModal = this.closeWarningModal.bind(this);
    this.handleRequestAddOpportunitySurvey = this.handleRequestAddOpportunitySurvey.bind(this);
  }

  requestShowCancelContactWindow(currentCancelContact) {
    this.setState({ currentCancelContact });
  }
  handleRequestShowOutreachPlan(currentSurveyPlan) {
    const { object, isAccount } = this.props;
    const id = isAccount ? object.account_id : object.opportunity_id;
    this.setState({ currentSurveyPlan: { ...currentSurveyPlan, object_id: id, object } });
    return Promise.resolve();
  }
  requestChangeSenderEmail(currentEditSenderSurvey) {
    const { object, isAccount } = this.props;
    const id = isAccount ? object.account_id : object.opportunity_id;
    this.setState({ currentEditSenderSurvey: { ...currentEditSenderSurvey, object_id: id, object } });
    return Promise.resolve();
  }
  requestChangeLanguage(currentEditLanguageSurvey, selectedLanguage, availableLanguages) {
    const { object, isAccount } = this.props;
    const id = isAccount ? object.account_id : object.opportunity_id;
    this.setState({
      currentEditLanguageSurvey: { ...currentEditLanguageSurvey, object_id: id },
      selectedLanguage,
      availableLanguages,
    });

    return Promise.resolve();
  }


  closeWarningModal() {
    this.props.dispatch(closeSummaryWindow());
  }
  handleCancelOutreach(contact, reason) {
    const { object, isAccount } = this.props;
    const contactId = contact.id;
    const collectorId = contact.collector_id;
    const id = isAccount ? object.account_id : object.opportunity_id;
    const p = this.props.dispatch(winLossCancelSurveys(collectorId, id, contactId, isAccount, reason, contact));
    return p;
  }

  handleRequestAddOpportunitySurvey(object) {
    this.props.dispatch(closeSummaryWindow());
    this.props.dispatch(requestEditWinLossOpportunityFeedbacks(object));
  }

  renderNoValidCollectorFound() {
    const { showSummaryWindow } = this.props;
    return (
      <Modal show={showSummaryWindow} onHide={this.closeWarningModal}>
        <Modal.Body>
          <div className="alert alert-warning">No valid collector found</div>
        </Modal.Body>
        <Modal.Footer>
          <Button bsStyle="default" onClick={this.closeWarningModal}>Close</Button>
        </Modal.Footer>
      </Modal>
    );
  }

  render() {
    const comps = [];
    comps.push((<SummaryWindow
      key="summary-window"
      requestCancelContact={this.requestShowCancelContactWindow}
      requestShowOutreachPlan={this.handleRequestShowOutreachPlan}
      requestChangeSenderEmail={this.requestChangeSenderEmail}
      requestChangeLanguage={this.requestChangeLanguage}
      requestAddContact={this.handleRequestAddOpportunitySurvey}
    />));
    comps.push((<SurveyEmailModal key="email-window" />));
    if (this.state.currentCancelContact !== null) {
      comps.push((<CancelOutreachForm
        key="cancel-contact"
        show
        contact={this.state.currentCancelContact}
        onClose={() => { this.setState({ currentCancelContact: null }); }}
        onRequestCancel={this.handleCancelOutreach}
      />));
    }
    comps.push((<OutreachPlanModal
      key="outreach"
      survey={this.state.currentSurveyPlan}
      onClose={() => { this.setState({ currentSurveyPlan: null }); }}
    />));
    comps.push((<EditSenderModal
      key="edit-sender"
      survey={this.state.currentEditSenderSurvey}
      onClose={() => { this.setState({ currentEditSenderSurvey: null }); }}
      onSuccess={() => {}}
    />));

    comps.push((<EditLanguageModal
      key="edit-language"
      survey={this.state.currentEditLanguageSurvey}
      selectedLanguage={this.state.selectedLanguage}
      availableLanguages={this.state.availableLanguages}
      onClose={() => {
        this.setState({
          currentEditLanguageSurvey: null,
          selectedLanguage: null,
          availableLanguages: [],
        });
      }}
      onSuccess={() => {}}
    />));

    comps.push((<RequestOpportunityFeedbacks
      key="add-contact"
      onSuccess={this.props.onSubmitContacts}
      onDone={this.props.onSubmitContactAndDone}
      collectorTypes={['decision']}
      onSellerFeedbackSuccess={this.props.onSellerFeedbackSuccess}
      requestCancelContact={this.props.requestCancelContact}
      requestChangeLanguage={this.requestChangeLanguage}
      requestExclude={this.props.requestExcludeOpportunity}
    />));


    return (
      <div className="container">
        <RequiredTVCollectorMappingSetup silent types={['decision']}>
          {(collectors) => {
            if (collectors.length > 0) {
              return comps;
            }
            return this.renderNoValidCollectorFound();
          }}
        </RequiredTVCollectorMappingSetup>
      </div>
    );
  }
}


Manager.propTypes = {
  dispatch: PropTypes.func.isRequired,
  object: PropTypes.shape({}).isRequired,
  isAccount: PropTypes.bool,
  showSummaryWindow: PropTypes.bool,
  onSubmitContacts: PropTypes.func,
  onSubmitContactAndDone: PropTypes.func,
  requestCancelContact: PropTypes.func,
  onSellerFeedbackSuccess: PropTypes.func,
  requestExcludeOpportunity: PropTypes.func,
};
Manager.defaultProps = {
  isAccount: false,
  showSummaryWindow: false,
  onSubmitContacts: () => {},
  onSubmitContactAndDone: () => {},
  onSellerFeedbackSuccess: () => {},
  requestCancelContact: () => {},
  requestExcludeOpportunity: null,
};
function mapStateToProps(state) {
  const object = getObject(state) || {};
  const isAccount = getIsAccount(state);
  return {
    object,
    isAccount,
    showSummaryWindow: getShowSummaryWindow(state),
  };
}
export default connect(mapStateToProps)(Manager);
